<ng-template #modalNotification>
    <div class="modal-header lookup-header">
        <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="closeFetchDataModal(lookupForm)">
            <span aria-hidden="true"> × </span>
        </button>
    </div>

    <div class="modal-body lookup-body">
        <div class="lookup-card d-flex align-items-center flex-column bg-white">
            <h2>Lookup User Data</h2>
            <p>Please add User’ mobile number below to see if his data already exists in database.</p>
            <form #lookupForm="ngForm" class="d-flex align-items-center justify-content-between flex-column" >
                <div class="mt-2 d-flex flex-column align-items-center justify-content-center">
                    <div class="confirmation-group d-flex justify-content-between">
                        <input
                            [ngClass]="{'invalid': !digitOne.valid &&  digitOne.touched || userExists == false, 'loading': loading, 'valid': userExists == true}"
                            #digitOne="ngModel" type="text" pattern="[0-9]+" minlength="3" maxlength="3"
                            placeholder="01X" (keyup)="onDigitInput($event)" ngModel required name="digiOne" [disabled]="userExists" [(ngModel)]="phone.digitOne"/>

                        <input
                            [ngClass]="{'invalid': !digitTwo.valid &&  digitTwo.touched || userExists == false, 'loading': loading, 'valid': userExists == true }"
                            #digitTwo="ngModel" type="text" pattern="[0-9]+" minlength="4" maxlength="4"
                            placeholder="XXXX" (keyup)="onDigitInput($event)" ngModel required name="digiTwo" [disabled]="userExists" [(ngModel)]="phone.digitTwo"/>

                        <input
                            [ngClass]="{'invalid': !digitThree.valid &&  digitThree.touched || userExists == false, 'loading': loading, 'valid': userExists == true}"
                            #digitThree="ngModel" type="text" pattern="[0-9]+" minlength="4" maxlength="4"
                            placeholder="XXXX" (keyup)="onDigitInput($event)" ngModel required name="digiThree" [disabled]="userExists" [(ngModel)]="phone.digitThree"/>

                    </div>
                    <span class="err-msg mt-2" *ngIf="!lookupForm.valid && lookupForm.dirty && lookupForm.touched">
                        Please Enter Valid Phone Number</span>
                    <span class="mt-4" *ngIf="userExists == true"> User Data Exists in database!</span>
                    <span class="mt-4" *ngIf="userExists == false"> User doesn't exist!</span>

                </div>

                <div class="result-valid" *ngIf="userExists == true">
                    <h3>Personal Details</h3>
                    <div class="data-container mt-3 d-flex justify-content-between">
                        <div class="data">
                            <h6>Full Name</h6>
                            <h4>{{user.fullName}}</h4>
                        </div>
                        <div class="data">
                            <h6>National ID</h6>
                            <h4>{{user.nationalId}}</h4>
                        </div>


                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-center flex-column">
        <span class="link-another color-primary mb-4" *ngIf="userExists !== null" (click)="onReset(lookupForm)">
          Try Another Number!
        </span>
        <button
          [ngClass]="{'loading': loading}"
          type="submit"
          class="btn btn-primary btn-round"
          [disabled]="(!lookupForm.valid && !user) || (!isFirstFetch && user)"
          (click)="onSubmit(lookupForm)"
        >
          {{ getActionLabel() }} </button>
    </div>
</ng-template>
